var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scale-with-screen"},[_c('div',{staticClass:"book-summary"},[_vm._m(0),_vm._v(" "),_c('div',[_c('div',{staticClass:"book-summary-text",domProps:{"innerHTML":_vm._s(_vm.summaryText)}})])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bpg-title"},[_c('span',[_vm._v("Summary")])])
}]

export { render, staticRenderFns }